<template>
  <BaseModal
    :id="'summary-mass-edit'"
    :title="`Summary`"
    :size="'lg'"
    :message="message"
    @close="close($event)"
  >
    <template v-slot:breadcrumb>
      <Breadcrumb :breadcrumb="breadcrumb_local" />
    </template>

    <template v-slot:content>
        <div
          class="w-100 table-responsive defaultproject__table overflow-y--2 table-fix-head"
        >
          <table class="table">
            <thead>
              <tr style="background-color: #fff">
                <th
                  style="font-weight: normal !important"
                  class="header-item-manual"
                  v-for="(item, i) in summary_table_headers"
                  :key="i"
                  scope="col"
                  v-html="item.name"
                />
              </tr>
            </thead>
            <tbody>
              <template>
                <tr v-for="(item, i) in validate_data" :key="i">
                  <td v-html="`${i + 1}`" />
                  <td
                    v-html="
                      item.associate
                    "
                  />
                  <td v-html="item.error" />
                </tr>
              </template>
            </tbody>
          </table>
        </div>
    </template>
  </BaseModal>
</template>
  
  <script>
import Breadcrumb from "@/components/BreadcrumbComponent/Breadcrumb";
import BaseModal from "@/components/BaseModal";
import Resources from "./resources";

export default {
  name: "DeleteValidationsModal",

  props: ["breadcrumb", "validate_data"],

  components: {
    BaseModal,
    Breadcrumb,
  },

  data() {
    return {
      summary_table_headers: Resources.summary_table_headers,
      breadcrumb_local: [...this.breadcrumb],
      message: `Due to inconsistencies in the data, some information of the following associates was not updated.`,
      select_all: true,
    };
  },

  methods: 
  {
    close(event) {
      this.$emit("close", event);
    },

  },

  computed: {},

  mounted() {
    this.breadcrumb_local[this.breadcrumb.length - 1].arrow =
      "<span class='slash'>/</span>";
    this.breadcrumb_local.push({
      name: "Validation Modal",
      arrow: "",
    });
  },
};
</script>
  